import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { getParameterByName } from '@src/utils/common-util';
import { jumpPage } from '@src/utils/common-util';

class DownloadStore extends BaseStore {
  @observable isActive = false;

  @observable article_title = '';
  @observable content = '';
  @observable date = 0;
  @observable categoryName = '';
  @observable back_btn = '';

  back = () => {
    // this.$history.goBack(-1);
    if (IS_DEV_ENV) {
      this.$history.push('/news-list');
    } else {
      jumpPage('news-list.html');
    }
  };

  /**
   * 获取文章详细信息
   * @param {string} contentId - 文章ID
   */
  getArticleDetail = async contentId => {
    const res = await window.FUN_LINK_SDK.getLayersData([{ layerId: 'article_detail', type: 'content', param: { contentId } }]);
    const article_detail = res?.data?.article_detail;
    if (!article_detail) {
      console.error('文章详情数据获取失败', res);
      return;
    }
    /**
     * 设置文章标题
     * @param {string} title - 文章标题
     */
    this.article_title = article_detail.title;
    /**
     * 设置文章内容
     * @param {string} content - 文章内容
     */
    this.content = article_detail.content;
    /**
     * 设置文章日期
     * @param {number} date - 文章日期
     */
    this.date = article_detail.date;
    /**
     * 设置文章分类
     * @param {string} categoryName - 文章分类
     */
    this.categoryName = article_detail.categoryName;
  };

  use() {
    super.use();
    const contentId = getParameterByName('contentId');
    useMount(() => {
      this.isActive = true;

      if (contentId) {
        this.getArticleDetail(contentId);
      } else {
        console.error('未提供contentId参数', this.$routeMatch.query);
      }
    });
  }
}

export default DownloadStore;
